import { AreaConfig, AreasConfig, NatsValue } from "types/Farm.js"
import { COMPONENTS } from "./create.js"



export function buildAlarms(): AreasConfig {
	return {

		growUnits: [
			{ code: COMPONENTS.CMP_1, areas: buildGrowUnit() },
			{ code: COMPONENTS.CMP_2, areas: buildGrowUnit() },
			{ code: COMPONENTS.CMP_3, areas: buildGrowUnit() },
			{ code: COMPONENTS.CMP_4, areas: buildGrowUnit() },
			{ code: COMPONENTS.CMP_5, areas: buildGrowUnit() },
		],

		areas: [

			{
				tags: ["alarm_co2"],
				name: "co2",
				code: COMPONENTS.HVAC,
				aliases: [
					"f_CO2_Alarm_Delayed", "f_CO2_Comm_Error", "f_CO2_Warning_Delayed",
					"CO2000_f_Alarm", "CO2000_f_Fault", "CO2000_f_Warning",
					"CO2001_f_Alarm", "CO2001_f_Fault", "CO2001_f_Warning",
					"CO2002_f_Alarm", "CO2002_f_Fault", "CO2002_f_Warning",
					"CO2003_f_Alarm", "CO2003_f_Fault", "CO2003_f_Warning",
					"CO2004_f_Alarm", "CO2004_f_Fault", "CO2004_f_Warning",
					"CO2005_f_Alarm", "CO2005_f_Fault", "CO2005_f_Warning",
				],
			},
			{
				tags: ["alarm_bottom"],
				name: "uta_1",
				code: COMPONENTS.HVAC,
				aliases: ["UTA1_Alarm", "UTA1_COMM_fError"],
			},
			{
				tags: ["alarm_top"],
				name: "uta_2",
				code: COMPONENTS.HVAC,
				aliases: ["UTA2_Alarm", "UTA2_COMM_fError"],
			},
			{
				tags: ["alarm_top"],
				name: "uta_3",
				code: COMPONENTS.HVAC,
				aliases: ["UTA3_Alarm", "UTA3_COMM_fError"],
			},
			{
				tags: ["alarm_bottom"],
				name: "osmosis",
				code: COMPONENTS.HVAC,
				aliases: [
					"COMM_fError", "f_Manteinance",
					"fAL128", "fAL129", "fAL130", "fAL131", "fAL132",
					"fAL133", "fAL134", "fAL135", "fAL136", "fAL137",
					"fAL138", "fAL139", "fAL140",
				]
			},
			{ 
				tags: ["alarm_bottom"],
				name: "chiller_1", 
				code: COMPONENTS.HVAC, 
				aliases: ["CHILLER_1_Alarm", "CHILLER_1_COMM_fError"] 
			},
			{ 
				tags: ["alarm_bottom"],
				name: "chiller_2", 
				code: COMPONENTS.HVAC, 
				aliases: ["CHILLER_2_Alarm", "CHILLER_2_COMM_fError"] 
			},
			{ 
				tags: ["alarm_top"],
				name: "chiller_3", 
				code: COMPONENTS.HVAC, 
				aliases: ["CHILLER_3_Alarm", "CHILLER_3_COMM_fError"] },
			{
				tags: ["alarm_germi"],
				name: "germi",
				code: COMPONENTS.GERM,
				aliases: [
					"COMM_fError", "f_Manteinance",
					"fAL130", "fAL131", "fAL132", "fAL133", "fAL134", "fAL135",
					"fAL136", "fAL137", "fAL138", "fAL139", "fAL140",
				]
			},
			{
				tags: ["alarm_bottom"],
				name: "ec_tc1",
				code: COMPONENTS.HVAC,
				aliases: [
					"naTC1_CO2_COMM_fError", "naTC1_Main_COMM_fError", "naTC1_OSMOSIS_COMM_fError",
					"naTC1_PMP_2002_COMM_fError", "naTC1_PMP_2XXX_COMM_fError", "naTC1_PMP_3002_COMM_fError",
					"naTC1_PMP_3XXX_COMM_fError", "naTC1_PMP_4001_COMM_fError", "naTC1_PMP_4201_COMM_fError",
					"naTC1_PMP_RISE_COMM_fError", "naTC1_UTA1_COMM_fError", "naTC1_UTA2_COMM_fError",
					"naTC1_Waste_Waters_COMM_fError", "naTC1_Chiller1_COMM_fError", "naTC1_Chiller2_COMM_fError",
					"nnaTC1_PMP_RISE_COMM_fError", "BMS_COMM_fError", "CT_SERVICES_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "ec_tc2",
				code: COMPONENTS.HVAC,
				aliases: [
					"naTC2_Chiller3_COMM_fError", "naTC2_Main_COMM_fError", "naTC2_PDC1_COMM_fError",
					"naTC2_PFC2_COMM_fError", "naTC2_PMP_5001_COMM_fError", "naTC2_PMP_5101_COMM_fError",
					"naTC2_UTA3_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "ec_tu",
				code: COMPONENTS.HVAC,
				aliases: [
					"naTU_BC_COMM_fError", "naTU_CA_COMM_fError", "naTU_CM_COMM_fError",
					"naTU_CW_COMM_fError", "naTU_GE_COMM_fError", "naTU_Main_COMM_fError",
					"naTU_PCKG1_COMM_fError", "naTU_PCKG2_COMM_fError", "naTU_PW_COMM_fError",
					"naTU_REF_COMM_fError", "naTU_RIARRANGIO_COMM_fError", "naTU_TW_COMM_fError",
				]
			},
			{
				tags: ["alarm_right"],
				name: "ec_gr",
				code: COMPONENTS.HVAC,
				aliases: [
					"naGR_Main_COMM_fError", "naGR_GU1_COMM_fError", "naGR_GU2_COMM_fError",
					"naGR_GU3_COMM_fError", "naGR_GU4_COMM_fError", "naGR_GU5_COMM_fError",
				]
			},
			{
				tags: ["alarm_bottom"],
				name: "ec_off",
				code: COMPONENTS.HVAC,
				aliases: [
					"naOF_Main_COMM_fError",
				]
			},
			{
				tags: ["alarm_left"],
				name: "ec_ced",
				code: COMPONENTS.HVAC,
				aliases: [
					"naOF_CED_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "ec_glv",
				code: COMPONENTS.HVAC,
				aliases: [
					"naGLV_Main_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "ec_cwm",
				code: COMPONENTS.HVAC,
				aliases: [
					"CWM_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "coldroom",
				code: COMPONENTS.HVAC,
				aliases: [
					"CR_TEMP_COMM_fError", "CR_UR_COMM_fError",
				]
			},
			{
				tags: ["alarm_top"],
				name: "blastchiller",
				code: COMPONENTS.HVAC,
				aliases: [
					"BCH_TEMP_COMM_fError", "BCH_UR_COMM_fError",
				]
			},
			{
				name: "generator",
				code: COMPONENTS.HVAC,
				aliases: [
					"VisaGen_COMM_fError",
				]
			}
		],
	}

}

function buildGrowUnit(): AreaConfig[] {

	const guPump = ["fAL131", "fAL132", "fAL133", "fAL134", "fAL135", "fAL136"]
	const guDrainage = ["fAL144", "fAL145", "fAL146", "fAL147", "fAL148", "fAL149"]
	const guRelanch = ["RELAUNCH_A_f_RelaunchAlarm", "RELAUNCH_B_f_RelaunchAlarm", "RELAUNCH_C_f_RelaunchAlarm", "RELAUNCH_D_f_RelaunchAlarm", "RELAUNCH_E_f_RelaunchAlarm", "RELAUNCH_F_f_RelaunchAlarm"]

	return [
		{ name: "tower.A.1", aliases: buildTowerG1(0, 3) },
		{ name: "tower.A.2", aliases: [...buildTowerG2(0, 3), guPump[0], guDrainage[0], guRelanch[0]], },

		{ name: "tower.B.1", aliases: buildTowerG1(4, 7), },
		{ name: "tower.B.2", aliases: [...buildTowerG2(4, 7), guPump[1], guDrainage[1], guRelanch[1]], },

		{ name: "tower.C.1", aliases: buildTowerG1(8, 11), },
		{ name: "tower.C.2", aliases: [...buildTowerG2(8, 11), guPump[2], guDrainage[2], guRelanch[2]], },

		{ name: "tower.D.1", aliases: buildTowerG1(12, 15), },
		{ name: "tower.D.2", aliases: [...buildTowerG2(12, 15), guPump[3], guDrainage[3], guRelanch[3]], },

		{ name: "tower.E.1", aliases: buildTowerG1(16, 19), },
		{ name: "tower.E.2", aliases: [...buildTowerG2(16, 19), guPump[4], guDrainage[4], guRelanch[4]], },

		{ name: "tower.F.1", aliases: buildTowerG1(20, 23), },
		{ name: "tower.F.2", aliases: [...buildTowerG2(20, 23), guPump[5], guDrainage[5], guRelanch[5]], },

		{ name: "fan_1", aliases: ["fAL138"] },
		{ name: "fan_2", aliases: ["fAL139"] },
		{ name: "fan_3", aliases: ["fAL140"] },

		{
			name: "mainTank",
			aliases: [
				"fAL004", "fAL005",
				"WK_TANK1_f_RefillMaxAmount", "WK_TANK1_f_RefillTimeout",
				"WK_TANK2_f_RefillMaxAmount", "WK_TANK2_f_RefillTimeout",
			]
		},
		{
			name: "ferti", aliases: [
				"ADJ_EC_Alarm_f_A1_Active", "ADJ_EC_Alarm_f_A2_Active", "ADJ_EC_Alarm_f_Out_Active",
				"ADJ_PH_Alarm_f_A1_Active", "ADJ_PH_Alarm_f_A2_Active", "ADJ_PH_Alarm_f_Out_Active",
				"fAL006", "fAL007", "fAL008", "fAL009", "fAL137", "fAL158", "fAL159",
				"FCK_f_Washing_Alarm",
				"WK_TANK_ACID_f_RefillMaxAmount", "WK_TANK_ACID_f_RefillTimeout", "WK_TANK_BASE_f_RefillMaxAmount",
				"WK_TANK_BASE_f_RefillTimeout", "WK_TANK_SOLA_f_RefillMaxAmount", "WK_TANK_SOLA_f_RefillTimeout",
				"WK_TANK_SOLB_f_RefillMaxAmount", "WK_TANK_SOLB_f_RefillTimeout",
			]
		},
		{
			name: "panel", aliases: [
				"COMM_fError",
				"f_Manteinance",
				"fAL000", "fAL001", "fAL002", "fAL003", "fAL128", "fAL129", "fAL130",
				"fAL141", "fAL142", "fAL143", "fAL150", "fAL151", "fAL152", "fAL153",
				"fAL154", "fAL155", "fAL156", "fAL157",
			]
		},
	]
}

function buildTowerG1(from: number, to: number): NatsValue[] {
	return Array.from({ length: (to - from) + 1 }, (_, i) => {
		const v = (i + from).toString().padStart(3, "0")
		return [`LAY${v}_f_Drainage_cfg_mismatch`, `LAY${v}_f_Irrigation_cfg_mismatch`, `LAY${v}_f_Lighting_cfg_mismatch`, `LAY${v}_I_f_Irrigation_Alarm`]
	})
}

function buildTowerG2(from: number, to: number): NatsValue[] {
	return Array.from({ length: (to - from) + 1 }, (_, i) => {
		const v = (i + from).toString().padStart(3, "0")
		return [`LAY${v}_f_Layer_cfg_mismatch`]
	})
}
